"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.canBookDate = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var getNextAvailableDay_1 = require("./getNextAvailableDay");
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var isDateBlackout_1 = require("./isDateBlackout");
dayjs_1.default.extend(utc_1.default);
var canBookDate = function (bookingDate, collectionDateConfig, day) {
    if (day === void 0) { day = dayjs_1.default.utc(); }
    var nextDay = getNextAvailableDay_1.getNextAvailableDay(collectionDateConfig, day).toDate();
    var isSameDayButBeforeCutOff = bookingDate.isSame(nextDay, "day") &&
        (bookingDate.isSame(nextDay, "hours") ||
            bookingDate.isBefore(nextDay, "hours"));
    var isAfterNextDay = bookingDate.isAfter(nextDay, "day");
    var isNotABlackout = !isDateBlackout_1.isDateBlackout(bookingDate, collectionDateConfig.blackoutDates || [], collectionDateConfig.blackoutDays || []);
    return (isSameDayButBeforeCutOff || isAfterNextDay) && isNotABlackout;
};
exports.canBookDate = canBookDate;
